import * as stylex from '@stylexjs/stylex'
import { type ElementType } from 'react'
import { Box, type BoxProps } from '../Box/Box'
import { colors } from '../tokens/colors.stylex'
import { typography } from '../tokens/typography.stylex'

const baseStyles = stylex.create({
  root: {
    alignItems: 'center',
    backgroundColor: colors.grey200,
    display: 'inline-flex',
    flexShrink: 0,
    fontWeight: typography.weightRegular,
    transitionDuration: '0.2s',
    transitionProperty: 'background-color, border-color',
    transitionTimingFunction: 'ease-in-out',
  },
})

/** ChipBase 的 props，繼承自 BoxProps */
export type ChipBaseProps<RootComponent extends ElementType = 'div', BoxElement extends HTMLElement = HTMLDivElement> = BoxProps<RootComponent, BoxElement>

/**
 * ChipBase 是 Chip 的底層基礎元件，提供 inline-flex 排版與預設背景色。
 * 一般不直接使用，請改用 Chip。
 */
export const ChipBase = <RootComponent extends ElementType = 'div', BoxElement extends HTMLElement = HTMLDivElement>(props: ChipBaseProps<RootComponent, BoxElement>) => {
  const { component = 'div', rootStyle, ...rest } = props

  return (
    <Box component={component} rootStyle={[baseStyles.root, rootStyle]} {...rest} />
  )
}
